import getModule from '../compile/type-engineer2-upd'

const Module = getModule({}, window['DEPACK_REQUIRE'])

export default Module